export const ProjectData = [
  {
    catigory : 'react',
    title : 'Amazon Clone',
    about : "it's an Amazon Clone which is an E-commerce that let you buy and any product you want with a lot of categories",
    tags : ["React" , "React-Router" , "React-Hooks" , "React Hook Form" , "Tailnwind Css" ,"Responsive Design" , "Axios" , "Redux" , "Redux Thunk" , "Firebase" , "Swiper.js"],
    demo : 'https://amazon-clone-six-eosin.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Amazon-Clone',
    images : '../../assets/amazon.png'
  },
  {
    catigory : 'react',
    title : 'Netflix Clone',
    about : "it's a Netflix Clone which is let you see the Traillers for your favorite movies and see their description and Rating",
    tags : ["React" , "Styled-Component" , "React-Router" , "React-Hooks" , "Custom Hook" , "Css-Modules" , "Sass" ,"Responsive Design" , "Axios"],
    demo : 'https://netflix-clone-ten-iota.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Netflix-Clone',
    images : '../../assets/netflix.png'
  },
  {
    catigory : 'react',
    title : 'Shopping Cart',
    about : "it's a Shopping Cart project which is let you buy a lot of categories of products and collect them in the cart , and easily to add or remove the product",
    tags : ["React" , "Redux" , "React-Router" , "React-Hooks" , "Custom Hook" , "React-Bootstrap" , "Responsive Design" , "Axios"],
    demo : 'https://shopping-cart-eight-silk.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Shopping-Cart',
    images : '../../assets/shopping-cart.png'
  },
  {
    catigory : 'react',
    title : 'Video Player',
    about : "it's a simple clone of Youtube that's let you watching an amazing videos and see the recommended for your search",
    tags : ["React" , "Hooks" , "Semantic Ui" , "Responsive Design" ] ,
    demo : 'https://video-functional-hooks.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Youtube-using-Hooks',
    images : '../../assets/videoplayer.png'
  },
  {
    catigory : 'vanilla js',
    title : 'Movie Search',
    about : "it's a Movies App that's makes you see your best movies easily and see the ratings and the description of each movie",
    tags : ["Javascript" , "API" , "Html5" , "Css3" , "Responsive Design"],
    demo : 'https://movies-app-sable-sigma.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Movies-App',
    images : '../../assets/movies.png'
  },
  {
    catigory : 'vanilla js',
    title : 'Bankist',
    about : "This is a landing page for online banking made use HTML, CSS and Vanilla javascript advanced DOM manipulation. some features like:- Lazy Loading Images, Dynamic Cards, and Testimonial Slider.Stack",
    tags : ["Javascript" , "Html5" , "Css3" , "Responsive Design"],
    demo :  'https://bankist-gsxl5ros4-ahmedkhaled13281.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Bankist',
    images : '../../assets/bankist 1.png'
  },
  {
    catigory : 'vanilla js',
    title : 'Weather App',
    about : "it's a Weather App that makes you see the weather in your city with geolocation and you can see any city by searching with it's name ",
    tags : ["Javascript" , "API" , "Html5" , "Css3" , "Responsive Design"],
    demo :  'https://weather-app-three-iota.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Weather-App',
    images : '../../assets/weather.png'
  },
  {
    id: 5,
    catigory : 'vanilla js',
    title : 'Rock Paper Scissor',
    about : "Rock paper scissors is a classic game with a very simple rule set which makes it perfect for a beginner game project",
    tags : ["Javascript" , "Html5" , "Css3" , "Responsive Design"],
    demo : 'https://rock-paper-scissor-kappa.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/Rock-Paper-Scissor/tree/main',
    images : '../../assets/rock.png'
  },
  {
    catigory : 'animation',
    title : 'Restaurant',
    about : "it's a Restaurant website with a beautiful animation and responsive design",
    tags : ["Javascript" , "Html5" , "Css3" , "Responsive Design" , "Animation"],
    demo : 'https://the-restaurant-28dvumpd1-ahmedkhaled13281.vercel.app/',
    github : 'https://github.com/AhmedKhaled13281/The-Restaurant',
    images : '../../assets/res.png'
  }

]
